import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import { type StackProps } from "@mui/system";

import { systemLabelsTxt } from "../assets/texts/CloudAnalytics";
import { type LabelWithRef } from "../Pages/CloudAnalytics/labels/types";
import { isSystemLabel } from "../Pages/CloudAnalytics/labels/utils";
import SystemLabel from "../Pages/CloudAnalytics/report/actionBar/SystemLabel";

type LabelListProps = {
  labels: Array<LabelWithRef>;
} & StackProps;

// Displays a list of labels as chips
// Used in the display of labels for cloud analytics types
const LabelList = ({ labels, sx }: LabelListProps) => {
  if (labels.length === 0) {
    return null;
  }

  return (
    <Stack
      direction="row"
      spacing={1}
      useFlexGap
      sx={[
        {
          flexWrap: "wrap",
          "& .MuiChip-root": {
            height: "20px",
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {labels.map((label) =>
        isSystemLabel(label.data.type ?? "") ? (
          <SystemLabel
            key={label.data.name}
            label={label.data.name}
            tooltip={systemLabelsTxt[label.data.name.toUpperCase()]?.TOOLTIP ?? label.data.name}
          />
        ) : (
          <Chip key={label.data.name} size="small" sx={{ bgcolor: label.data.color }} label={label.data.name} />
        )
      )}
    </Stack>
  );
};

export default LabelList;
